import createIcon from '../../createIcon';

/**
 * @component @name CancelScheduleSend
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNy41QzE1LjU4IDcuNSAxNS4xNyA3LjU0IDE0Ljc2IDcuNjFMMC41MSAxLjVMMC41IDguNUw5LjUgMTAuNUwwLjUgMTIuNUwwLjUxIDE5LjVMOC41OCAxNi4wNEM5LjA5IDE5LjY5IDEyLjIxIDIyLjUgMTYgMjIuNUMyMC4xNCAyMi41IDIzLjUgMTkuMTQgMjMuNSAxNUMyMy41IDEwLjg2IDIwLjE0IDcuNSAxNiA3LjVaTTE2IDIwLjVDMTIuOTcgMjAuNSAxMC41IDE4LjAzIDEwLjUgMTVDMTAuNSAxMS45NyAxMi45NyA5LjUgMTYgOS41QzE5LjAzIDkuNSAyMS41IDExLjk3IDIxLjUgMTVDMjEuNSAxOC4wMyAxOS4wMyAyMC41IDE2IDIwLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuNzcgMTIuNTNMMTYgMTQuMjlMMTQuMjMgMTIuNTNMMTMuNTMgMTMuMjNMMTUuMjkgMTVMMTMuNTMgMTYuNzdMMTQuMjMgMTcuNDdMMTYgMTUuNzFMMTcuNzcgMTcuNDdMMTguNDcgMTYuNzdMMTYuNzEgMTVMMTguNDcgMTMuMjNMMTcuNzcgMTIuNTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CancelScheduleSend = createIcon('CancelScheduleSend', [
  [
    'path',
    {
      d: 'M16 7.5C15.58 7.5 15.17 7.54 14.76 7.61L0.51 1.5L0.5 8.5L9.5 10.5L0.5 12.5L0.51 19.5L8.58 16.04C9.09 19.69 12.21 22.5 16 22.5C20.14 22.5 23.5 19.14 23.5 15C23.5 10.86 20.14 7.5 16 7.5ZM16 20.5C12.97 20.5 10.5 18.03 10.5 15C10.5 11.97 12.97 9.5 16 9.5C19.03 9.5 21.5 11.97 21.5 15C21.5 18.03 19.03 20.5 16 20.5Z',
      key: 's9voy9',
    },
  ],
  [
    'path',
    {
      d: 'M17.77 12.53L16 14.29L14.23 12.53L13.53 13.23L15.29 15L13.53 16.77L14.23 17.47L16 15.71L17.77 17.47L18.47 16.77L16.71 15L18.47 13.23L17.77 12.53Z',
      key: '15dpxy',
    },
  ],
]);

export default CancelScheduleSend;
